// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__2lUr6","content":"RecentSearches_content__ypx5k"};